import { useEffect, useRef } from 'react';
import axios from 'axios';
import { useConfig } from '../contexts/FrontendConfigContext';
import { useFronteggToken, useUserInfo } from './useFrontegg';

const BASE_URL = process.env.REACT_APP_BASE_URL || '';

export default function useActivityHeartbeat() {
    const heartbeatMs = useConfig('USER_ACTIVITY_HEARTBEAT_MS', 60000);
    const token = useFronteggToken();
    const user = useUserInfo();
    const timerRef = useRef(null);

    useEffect(() => {
        if (!token || !user) return undefined;

        const beat = async () => {
            if (document.visibilityState !== 'visible') return;
            try {
                await axios.post(
                    `${BASE_URL}/api/user-activity/heartbeat`,
                    {},
                    { headers: { Authorization: `Bearer ${token}` }, timeout: 5000 }
                );
            } catch (_) { /* fire-and-forget */ }
        };

        beat();
        const interval = Math.max(Number(heartbeatMs) || 60000, 15000);
        timerRef.current = setInterval(beat, interval);

        const onEnd = () => {
            try {
                const url = `${BASE_URL}/api/user-activity/end`;
                const blob = new Blob(
                    [JSON.stringify({ token })],
                    { type: 'application/json' }
                );
                navigator.sendBeacon?.(url, blob);
            } catch (_) { /* noop */ }
        };

        window.addEventListener('pagehide', onEnd);
        window.addEventListener('beforeunload', onEnd);

        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
            window.removeEventListener('pagehide', onEnd);
            window.removeEventListener('beforeunload', onEnd);
        };
    }, [token, user, heartbeatMs]);
}
